import React from 'react';

import Paper from '@mui/material/Paper';
import Typography from '@mui/material/Typography';
import TableContainer from '@mui/material/TableContainer';
import Table from '@mui/material/Table';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import IconButton from '@mui/material/IconButton';

import { MdDelete, MdDownload, MdEdit, MdSource } from 'react-icons/md';

import {
  BtnFolderStyled,
  HeaderPageStyled,
  RootStyled,
  UploadContainerStyled,
  ButtonsActionsStyled,
  CellBodyStyled,
  CellHeaderStyled,
} from './index.styles';

import { MOCK_PHOTOS } from '../../../../../../../services/driverJS/mocks';

export function TourPhotos() {
  return (
    <Paper>
      <RootStyled>
        <HeaderPageStyled>
          <Typography style={{ fontSize: '24px' }} variant="h1">
            Obra Tour
          </Typography>
          <UploadContainerStyled>
            <BtnFolderStyled
              id="create-folder"
              color="secondary"
              variant="contained"
            >
              Criar pasta
            </BtnFolderStyled>
          </UploadContainerStyled>
        </HeaderPageStyled>
        <TableContainer style={{ marginTop: 16 }} id="folder-table">
          <Table stickyHeader>
            <TableHead>
              <TableRow>
                {[' ', 'Pasta', 'Data da última modificação', 'Ações'].map(
                  (heading) => (
                    <CellHeaderStyled key={heading}>{heading}</CellHeaderStyled>
                  )
                )}
              </TableRow>
            </TableHead>
            <TableBody>
              {MOCK_PHOTOS.map((row) => (
                <TableRow key={row.id}>
                  <TableCell>
                    <MdSource size={20} />
                  </TableCell>
                  {['name', 'last_modified'].map((cell) => (
                    <CellBodyStyled key={cell}>{row[cell]}</CellBodyStyled>
                  ))}
                  <ButtonsActionsStyled>
                    <IconButton className="buttonEdit" size="large">
                      <MdEdit size={24} />
                    </IconButton>
                    <IconButton className="buttonEdit" size="large">
                      <MdDownload size={24} />
                    </IconButton>
                    <IconButton className="buttonDelete" size="large">
                      <MdDelete size={24} />
                    </IconButton>
                  </ButtonsActionsStyled>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>
      </RootStyled>
    </Paper>
  );
}
